export const meta: BlockMeta = {
  title: "Numbered Rows Sublist Item",
  description: "A single numbered row",
  keywords: ["content"],
  icon: "book-alt",
  category: "layouts",
}

import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { useState } from "react"
import { tv } from "tailwind-variants"
import { Spacer } from "@components/atoms/Spacer"
import { Divider } from "@components/atoms/Divider"

const variants = tv({
  base: "!type-title-xs-medium [&_.sub-item-title]:!type-title-xs-medium",
  variants: {
    admin: {
      true: "",
    },
  },
  defaultVariants: {
    admin: false,
  },
})

export default defineBlock("content/numbered-rows-sub-item", (props) => {
  return (
    <li className={variants({ admin: env.admin })}>
      <EditableText
        as="span"
        className="sub-item-title py-2 pl-numberedRowsIndent"
        store="title"
        inlineToolbar={false}
        defaultValue="Example title"
        placeholder="Example title"
      />
      <div className="!type-body-m-roman my-2 [&_p]:py-2 [&_ul]:py-2 [&_ul]:ml-numberedRowsIndent [&_ul]:pl-numberedRowsIndent [&_ul_li]:before:hidden [&_ul_li]:list-disc [&_ol]:py-2 [&_ol]:ml-numberedRowsIndent [&_ol]:pl-numberedRowsIndent [&_ol_li]:before:hidden [&_ol_li]:list-decimal">
        <InnerBlocks
          allowedBlocks={["core/paragraph", "core/list"]}
          template={[["core/paragraph", { placeholder: "Enter body content" }]]}
          orientation="vertical"
        />
      </div>
    </li>
  )
})
